import { EuiFlexGroup, EuiSuperSelect } from '@elastic/eui';
import * as S from './RangeFilter.styles';
import { useMemo } from 'react';
interface RangeFilterProps {
  onChange: (p: RangeFilterProps['values']) => void;
  values: { min: string; max: string };
  data: Array<{
    value: string;
    inputDisplay: string;
  }>;
}

export const RangeFilter: (p: RangeFilterProps) => JSX.Element = ({ data, onChange, values }) => {
  const current = values;

  const defaultRange = useMemo(() => {
    return data.reduce(
      (acc, item) => {
        const value = parseInt(item.value, 10);
        if (value > acc.max) acc.max = value;
        if (value < acc.min) acc.min = value;
        return acc;
      },
      { max: -Infinity, min: Infinity }
    );
  }, [data]);

  const minOptions = data.filter(({ value }) => parseInt(value) <= parseInt(current?.max ?? defaultRange.max));
  const maxOptions = data.filter(({ value }) => parseInt(value) >= parseInt(current?.min ?? defaultRange.min));

  return (
    <EuiFlexGroup direction="column">
      <EuiFlexGroup gutterSize={'none'}>
        <S.RangeFilterItem>
          <EuiSuperSelect
            options={minOptions}
            valueOfSelected={String(current?.min ?? defaultRange.min)}
            onChange={(v): void => {
              onChange({ min: v, max: values?.max ?? String(defaultRange.max) });
            }}
          />
        </S.RangeFilterItem>
        <S.RangeFilterItem>
          <EuiSuperSelect
            options={maxOptions}
            valueOfSelected={String(current?.max ?? defaultRange.max)}
            onChange={(v): void => {
              onChange({ min: values?.min ?? String(defaultRange.min), max: v });
            }}
          />
        </S.RangeFilterItem>
      </EuiFlexGroup>
    </EuiFlexGroup>
  );
};
